import script from "./ClaimFAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimFAQ.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./ClaimFAQ.vue?vue&type=style&index=0&id=3a045140&module=s&lang=scss"
cssModules["s"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__